import { Component, inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EstadosDocumentoComponent } from '../../../../commons/estados-documento/estados-documento.component';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateService, MY_DATE_FORMATS } from '../../../../shared/date.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ListadoDocumentoPaginado, Documento } from '../../../../models/Document';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../../commons/toast.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppTitleService } from '../../../../services/app-title.service';
import { DocumentoService } from '../../../../services/documento.service';
import { map, merge, Observable, startWith } from 'rxjs';
import { DocumentType } from '../../../../models/DocumentType';
import { NoDataFoundComponent } from "../../../../commons/no-data-found/no-data-found.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AutofocusDirective } from '../../../../helpers/autofocus.directive';
import { ServidorPublico } from '../../../../models/ServidorPublico';
import { participanteValidator } from '../../../../commons/reasignar/reasignar.component';
import { ParticipanteService } from '../../../../services/participante.service';
import { UltimoUsoPipe } from '../../../../pipes/ultimo-uso.pipe';
import { AsyncPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DlgAdmReasignaComponent } from '../dlg-adm-reasigna/dlg-adm-reasigna.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-bandeja-reasignados',
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    AutofocusDirective,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressBarModule,
    UltimoUsoPipe,
    AsyncPipe,
    EstadosDocumentoComponent,
    NoDataFoundComponent,
    MatProgressSpinnerModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  templateUrl: './bandeja-adm-reasignar.component.html',
  styleUrl: './bandeja-adm-reasignar.component.scss'
})
export class BandejaAdmReasignarComponent {
  displayedColumns: string[] = ['select', 'estados', 'asunto', 'fecha', 'numeroDocumento'];
  documentsPaginated: ListadoDocumentoPaginado | undefined
  dataSource = new MatTableDataSource<Documento>([]);
  selection = new SelectionModel<Documento>(true, []);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  resultsLength = 0;
  isLoadingResults = false;

  documentTypes: DocumentType[] | undefined

  dateRangeInWeeks = 5
  maxDate = new Date()

  snackbarData: ScnackbarData = {}

  loading = false
  checkIfDisabled = false

  filterForm = new FormGroup({
    fechaInicio: new FormControl(new Date("2025-01-01"), {
      validators: [
        Validators.required
      ]
    }),
    fechaFin: new FormControl(new Date(), {
      validators: [
        Validators.required,
      ]
    }),
    searchText: new FormControl(""),
    participante: new FormControl<ServidorPublico>({ id: 0, usuario: "", apellidos: "", nombres: "", correo: "", estado: 0, telefono: "", telefonoMovil: "", departamento: "", cargo: "", titulo: "", ciruc: "", fechaUso: "" }, {
      validators: [Validators.required, participanteValidator()]
    }),
  })
  participantes: ServidorPublico[] = []
  participantesFiltered?: Observable<ServidorPublico[]>

  constructor(
    private documentoSrv: DocumentoService,
    private router: Router,
    private participanteService: ParticipanteService,
    public dialog: MatDialog,
    public dlg: MatDialog,
    private toast: ToastService,
    private dateService: DateService,
    private cdr: ChangeDetectorRef
  ) {
    inject(AppTitleService).setTitle("Administraci\xf3n");    
    this.participanteService.todosSp().subscribe({
      next: (response) => {        
          response.sort(function (a, b) {
            if (a.apellidos > b.apellidos) { return 1; }
            if (a.apellidos < b.apellidos) { return -1; }
            return 0;
          });
          this.participantes = response
          this.participantesFiltered = this.filterForm.controls.participante.valueChanges.pipe(
            startWith(''),
            map(value => {
              const nombres = typeof value === 'string' ? value : value?.nombres;
              return nombres ? this._filterParticipante(nombres as string) : this.participantes.slice();
            }),
          );
          this.filterForm.controls.participante.enable()       
      }
    })
  }

  ngOnInit(): void {
    const currentDate = new Date()
    let initialDate = new Date("2025-01-02");    
    this.filterForm.controls.fechaFin.setValue(currentDate)
    this.filterForm.controls.fechaInicio.setValue(initialDate)
  }

  ngAfterViewInit(): void {
    const label = document.getElementById(this.paginator._pageSizeLabelId)
    if (label) { label.textContent = "Items por p\xe1gina" }

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    Object.keys(this.filterForm.controls).forEach(controlName => {
      if (controlName !== 'searchText') {
        this.filterForm.get(controlName)?.valueChanges.subscribe(_ => this.onControlValueChanged());
      }
    });

    merge(this.sort.sortChange, this.paginator.page).pipe(
      startWith({}),
    ).subscribe(() => {
      if (this.filterForm.controls.participante.value?.id) {
        this.fectchAndInitializeDataSource();
      }
    });
  }

  onKeyUp(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13 
      ? e.preventDefault()
      : this.onControlValueChanged();
  }

  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  onControlValueChanged(): void {
    if (this.paginator) { this.paginator.pageIndex = 0 }
    if (this.filterForm.controls.participante.value?.id) {
      this.fectchAndInitializeDataSource()
    }
  }

  reload() {
    this.selection.clear()
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  fectchAndInitializeDataSource() {
    this.isLoadingResults = true;
    const filterData = this.createFilterData()
    this.documentoSrv!.getListadoAdmDocumentos(
      filterData.initialDate,
      filterData.endDate,
      filterData.searchText,
      filterData.userId,
      this.paginator.pageIndex + 1,
    ).subscribe({
      next: (response) => {
        this.documentsPaginated = response as ListadoDocumentoPaginado
        this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
        this.resultsLength = this.documentsPaginated.totalDocumentos;
        this.isLoadingResults = false;
        
        this.cdr.detectChanges();
      }
    })
  }

  onParticipanteSelected(participante: ServidorPublico) {
    if (!participante) { return }
    this.filterForm.controls.participante.setValue(participante);
    this.onControlValueChanged();
  }

  displayParticipanteFn(participante: ServidorPublico): string {
    return participante && participante.nombres ? participante.apellidos + " " + participante.nombres : '';
  }

  private _filterParticipante(filter: string): ServidorPublico[] {
    const filterValue = filter.toLowerCase();

    return this.participantes.filter(participante =>
      participante.nombres?.toLowerCase().includes(filterValue) ||
      participante.apellidos?.toLocaleLowerCase().includes(filterValue) ||
      participante.cargo?.toLowerCase().includes(filterValue) ||
      participante.ciruc.includes(filterValue));
  }

  onReasignar(tipo: number) {

    if (tipo === 0) {

      if (this.selection.selected.length === 0) {
        this.snackbarData.message = "Seleccione al menos un documento"
        this.snackbarData.style = SnackbarStyles.Warning
        this.snackbarData.iconName = "warning"
        this.toast.show(this.snackbarData)
        return
      }

      const dialogRef = this.dialog.open(DlgAdmReasignaComponent, {
        data: {
          participantes: this.participantes,
          documentIDs: this.selection.selected.map(document => document.idTarea),
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        this.selection.clear()
        this.dataSource = new MatTableDataSource<Documento>([])
        this.fectchAndInitializeDataSource();
      });

    } else {

      this.loading = true;
      this.checkIfDisabled = true;

      this.snackbarData.message = "Todos"
      this.snackbarData.style = SnackbarStyles.Info
      this.snackbarData.iconName = "info"
      this.toast.show(this.snackbarData)

    }


  }

  clickedRow(row: Documento) {
    this.router.navigateByUrl("/resumen/" + row.idTarea)
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource!.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource!.data);
  }

  checkboxLabel(row?: Documento): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  private createFilterData(): any {
    const filterData: any = {
      initialDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaInicio.value!),
      endDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaFin.value!),
      userId: this.filterForm.controls.participante.value!.id,
      searchText: this.filterForm.controls.searchText.value!
    }
    return filterData
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

}
